
const getKeyList = async (mvcmydashboard) => {
	var list = [];

	let sessionuuid = await mvcmydashboard.getCurrentSession();
	let bRefresh = true;
	let keys = await mvcmydashboard.getSessionCryptoKeys(sessionuuid, bRefresh).catch(err => {});

	for (var i = 0; i < (keys ? keys.length : 0); i++) {
		let key = keys[i];
		let record = {id: key.uuid, uuid: key.uuid, 
			address: key.address, description: key.description, 
			origin: key.origin,
			public_key: key.public_key };

		list.push(record);
	}

	return list;
};


export default {
	getFullList: async (mvcmydashboard) => {
		let list = [];

		if (!mvcmydashboard) return list;

		list = await getKeyList(mvcmydashboard);

		return list;
	},

/*	getList: async (mvcmydashboard, params) => {
		const { page, perPage } = params.pagination;
		const { field, order } = params.sort;

		var list = [];

		if (!mvcmydashboard) return {data: list, total: list.length};

		list = await getKeyList(mvcmydashboard);

		return {data: list, total: list.length};
	},

 	getOne: async (mvcmydashboard, params) => {
		const { id } = params.id;

		let item = {id};

		if (!mvcmydashboard) return {data: item};

		let list = await getKeyList(mvcmydashboard);

		for (var i = 0; i < (list ? list.length: 0); i++) {
			if (list[i] && list[i].id === id) {
				item = list[i];
				break;
			}
		}

		return {data: item}
	},

 */	getMany: async (mvcmydashboard, params) => {
		throw new Error('getMany not implemented');
	},

	getManyReference: async (mvcmydashboard, params) => {
		throw new Error('getManyReference not implemented');
	},

	update: async (mvcmydashboard, params) => {
		throw new Error('update not implemented');
	},

	updateMany: async (mvcmydashboard, params) => {
		throw new Error('updateMany not implemented');
	},

	create: async (mvcmydashboard, params) => {
		throw new Error('create not implemented');
	},

	delete: async (mvcmydashboard, params) => {
		throw new Error('delete not implemented');
	},

	deleteMany: async (mvcmydashboard, params) => {
		throw new Error('deleteMany not implemented');
	},

};